// Code highly inspired from https://github.com/auth0/auth0-spa-js/blob/master/src/storage.ts

/**
 * Defines a type that handles storage to/from a storage location
 */

/**
 * A storage protocol for marshalling data to/from session storage
 */
var SessionStorage = {
  get: function get(key) {
    if (typeof sessionStorage === 'undefined') {
      return;
    }
    var value = sessionStorage.getItem(key);
    if (value === null || value === undefined) {
      return;
    }
    return JSON.parse(value);
  },
  save: function save(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  remove: function remove(key) {
    sessionStorage.removeItem(key);
  }
};

export { SessionStorage };
